import {GET_FORM_USER_MANAGEMENT_VENDOR} from 'shared/constants/ActionTypes';

const initialState = {
  form: {
    username: '',
    name: '',
    nip: '',
    email: '',
    phone: '',
    role: '',
    genderMale: '',
    file: '',
    fileName: '',
    vendorBranch: {},
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_USER_MANAGEMENT_VENDOR:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
